import { ChevronRight } from "@components/Icons"
import { Box } from "@components/Layout"
import { ParagraphStyle } from "@components/Typography/TextStyles/Paragraph"
import styled, { css } from "styled-components"

export const Chevron = styled(ChevronRight)`
  width: 0.75rem;
  height: 0.75rem;
  fill: ${(p) => p.theme.colors.text.light};
`

export const SingleWrapper = styled(Box)<{ last?: boolean }>`
  display: flex;
  align-items: center;

  svg {
    margin: 0 1rem;
  }
  a {
    color: ${(p) => p.theme.colors.text.light};
    transition: color 0.15s ease;
    position: relative;

    &:hover {
      color: ${(p) => p.theme.colors.purple};

      &:after {
        height: 1px;
      }
    }

    &:after {
      content: "";
      display: block;
      height: 0;
      width: 100%;
      position: absolute;
      bottom: -2px;
      left: 0;
      background-color: ${(p) => p.theme.colors.purple};
    }

    ${(p) =>
      p.last &&
      css`
        cursor: default;
        &:hover {
          color: ${(p) => p.theme.colors.text.light};
          &:after {
            display: none;
          }
        }
      `}
  }
`

export const Anchor = styled.a`
  ${ParagraphStyle};
  color: ${(p) => p.theme.colors.text.light};
  cursor: pointer;
  text-decoration: none;
`
